import styled from 'styled-components'

export const Label = styled.div<{ isError?: boolean }>`
  font-family: 'Open Sans';
  font-size: 12px;
  color: ${({ isError }) => (isError ? '#F06060' : '#8b949b')};
`
